import HelperCookie from "./HelperCookie";

export function _extractDomainTLD(domainNameFull) {
	// Валидира име на домейн.
	domainNameFull = domainNameFull.toLowerCase().trim();
	const arrDomainData = domainNameFull.split('.');
	const domainName = arrDomainData[0];
	return domainNameFull.substr(domainName.length + 1);
}

export function _scorePassword(pass) {
	let hasConsecutive = false;
	let posl = '01234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	for (let i = 0; i <= posl.length - 3; i++) {
		let slice1 = posl.slice(i, i + 3);
		let slice2 = slice1.split("").reverse().join("");

		hasConsecutive = hasConsecutive || (pass.indexOf(slice1) >= 0);
		hasConsecutive = hasConsecutive || (pass.indexOf(slice2) >= 0);
		if (hasConsecutive) {
			break;
		}
	}

	let score = 0;
	if (!pass) return score;

	// award every unique letter until 5 repetitions
	let letters = {};
	for (let i = 0; i < pass.length; i++) {
		letters[pass[i]] = (letters[pass[i]] || 0) + 1;
		score += 5 / letters[pass[i]];
	}

	// bonus points for mixing it up
	let variations = {
		digits: /\d/.test(pass),
		lower: /[a-z]/.test(pass),
		upper: /[A-Z]/.test(pass),
		nonWords: /\W/.test(pass),
	};

	let variationCount = 0;
	for (let check in variations) {
		variationCount += variations[check] === true ? 1 : 0;
	}
	score += (variationCount - 1) * 7;
	if (hasConsecutive) {
		score = score - 10;
	}
	return Math.round(score);
}

export function _truncateDomainName(domainNameFull, domain_tld, maxLen) {
	const domainFullLen = domainNameFull.length;
	if (domainFullLen <= maxLen) {
		return domainNameFull;
	}
	const lastPartLen = domain_tld.length + 5;
	const dotsCount = 1;
	const lastPart = domainNameFull.substring(domainFullLen - lastPartLen);
	const firstPart = domainNameFull.substring(0, maxLen - lastPartLen - dotsCount)
	return firstPart + '…' + lastPart;
}

export function _isInViewport(element, partiallyVisible = false) {
	if (!element) return false;
	const rect = element.getBoundingClientRect();
	const elemTop = rect.top;
	const elemBottom = rect.bottom;

	// Partially visible elements return true:
	if (partiallyVisible) {
		return elemTop < (window.innerHeight / 2) && elemBottom >= 0;
	}
	// Only completely visible elements return true:
	return (elemTop >= 0) && (elemBottom <= window.innerHeight);
}

export function _isMobile() {
	return window.innerWidth < 768;
}

export function _isTablet() {
	return window.innerWidth >= 768 && window.innerWidth < 1024;
}

export function _isDesktop() {
	return window.innerWidth >= 1024;
}

/**
 * Създава fingerprint за конкретният браузер
 * Запазва го като cookie (за да може да се ползва между различните поддомени)
 * и в local storage.
 *
 */
export function _manageFingerPrint() {
	const fpvalue = 'hfrvllcstor';
	let ls = null;
	let cv = null;
	let rn = null;
	if (!window.localStorage) {
		return;
	}
	ls = window.localStorage.getItem(fpvalue);
	cv = HelperCookie.getCookie(fpvalue);

	if ((ls === cv) && (ls !== '')) {
		return;
	}

	if (!ls) {
		rn = cv;
		if (!cv) {
			rn =
			  Math.random().toString(36).substring(2, 9) +
			  Math.random().toString(36).substring(2, 9) + Date.now().toString(16);
		}
	} else {
		rn = ls;
	}

	if ((!ls) || (!cv)) {
		const a = window.location.hostname.split('.');
		const d = a[a.length - 2] + '.' + a[a.length - 1];
		window.localStorage.setItem(fpvalue, rn);
		HelperCookie.setCookie(fpvalue, rn, 720, d);
	}
}

export function _translateToLatin(value) {
	let lt = [];
	lt['а'] = 'a';
	lt['б'] = 'b';
	lt['в'] = 'v';
	lt['г'] = 'g';
	lt['д'] = 'd';
	lt['е'] = 'e';
	lt['ж'] = 'zh';
	lt['з'] = 'z';
	lt['и'] = 'i';
	lt['й'] = 'y';
	lt['к'] = 'k';
	lt['л'] = 'l';
	lt['м'] = 'm';
	lt['н'] = 'n';
	lt['о'] = 'o';
	lt['п'] = 'p';
	lt['р'] = 'r';
	lt['с'] = 's';
	lt['т'] = 't';
	lt['у'] = 'u';
	lt['ф'] = 'f';
	lt['х'] = 'h';
	lt['ц'] = 'ts';
	lt['ч'] = 'ch';
	lt['ш'] = 'sh';
	lt['щ'] = 'sht';
	lt['ъ'] = 'a';
	lt['ь'] = 'y';
	lt['ю'] = 'yu';
	lt['я'] = 'ya';
	lt['№'] = 'N.';
	lt['\\'] = ' ';
	lt['/'] = ' ';
	lt['À'] = 'A';
	lt['Á'] = 'A';
	lt['Â'] = 'A';
	lt['Ã'] = 'A';
	lt['Ä'] = 'A';
	lt['Å'] = 'A';
	lt['Æ'] = 'AE';
	lt['Ç'] = 'C';
	lt['È'] = 'E';
	lt['É'] = 'E';
	lt['Ê'] = 'E';
	lt['Ë'] = 'E';
	lt['Ì'] = 'I';
	lt['Í'] = 'I';
	lt['Î'] = 'I';
	lt['Ï'] = 'I';
	lt['Ð'] = 'D';
	lt['Ñ'] = 'N';
	lt['Ò'] = 'O';
	lt['Ó'] = 'O';
	lt['Ô'] = 'O';
	lt['Õ'] = 'O';
	lt['Ö'] = 'O';
	lt['Ø'] = 'O';
	lt['Ù'] = 'U';
	lt['Ú'] = 'U';
	lt['Û'] = 'U';
	lt['Ü'] = 'U';
	lt['Ý'] = 'Y';
	lt['ß'] = 's';
	lt['à'] = 'a';
	lt['á'] = 'a';
	lt['â'] = 'a';
	lt['ã'] = 'a';
	lt['ä'] = 'a';
	lt['å'] = 'a';
	lt['æ'] = 'ae';
	lt['ç'] = 'c';
	lt['è'] = 'e';
	lt['é'] = 'e';
	lt['ê'] = 'e';
	lt['ë'] = 'e';
	lt['ì'] = 'i';
	lt['í'] = 'i';
	lt['î'] = 'i';
	lt['ï'] = 'i';
	lt['ñ'] = 'n';
	lt['ò'] = 'o';
	lt['ó'] = 'o';
	lt['ô'] = 'o';
	lt['õ'] = 'o';
	lt['ö'] = 'o';
	lt['ø'] = 'o';
	lt['ù'] = 'u';
	lt['ú'] = 'u';
	lt['û'] = 'u';
	lt['ü'] = 'u';
	lt['ý'] = 'y';
	lt['ÿ'] = 'y';
	lt['Ā'] = 'A';
	lt['ā'] = 'a';
	lt['Ă'] = 'A';
	lt['ă'] = 'a';
	lt['Ą'] = 'A';
	lt['ą'] = 'a';
	lt['Ć'] = 'C';
	lt['ć'] = 'c';
	lt['Ĉ'] = 'C';
	lt['ĉ'] = 'c';
	lt['Ċ'] = 'C';
	lt['ċ'] = 'c';
	lt['Č'] = 'C';
	lt['č'] = 'c';
	lt['Ď'] = 'D';
	lt['ď'] = 'd';
	lt['Đ'] = 'D';
	lt['đ'] = 'd';
	lt['Ē'] = 'E';
	lt['ē'] = 'e';
	lt['Ĕ'] = 'E';
	lt['ĕ'] = 'e';
	lt['Ė'] = 'E';
	lt['ė'] = 'e';
	lt['Ę'] = 'E';
	lt['ę'] = 'e';
	lt['Ě'] = 'E';
	lt['ě'] = 'e';
	lt['Ĝ'] = 'G';
	lt['ĝ'] = 'g';
	lt['Ğ'] = 'G';
	lt['ğ'] = 'g';
	lt['Ġ'] = 'G';
	lt['ġ'] = 'g';
	lt['Ģ'] = 'G';
	lt['ģ'] = 'g';
	lt['Ĥ'] = 'H';
	lt['ĥ'] = 'h';
	lt['Ħ'] = 'H';
	lt['ħ'] = 'h';
	lt['Ĩ'] = 'I';
	lt['ĩ'] = 'i';
	lt['Ī'] = 'I';
	lt['ī'] = 'i';
	lt['Ĭ'] = 'I';
	lt['ĭ'] = 'i';
	lt['Į'] = 'I';
	lt['į'] = 'i';
	lt['İ'] = 'I';
	lt['ı'] = 'i';
	lt['Ĳ'] = 'IJ';
	lt['ĳ'] = 'ij';
	lt['Ĵ'] = 'J';
	lt['ĵ'] = 'j';
	lt['Ķ'] = 'K';
	lt['ķ'] = 'k';
	lt['Ĺ'] = 'L';
	lt['ĺ'] = 'l';
	lt['Ļ'] = 'L';
	lt['ļ'] = 'l';
	lt['Ľ'] = 'L';
	lt['ľ'] = 'l';
	lt['Ŀ'] = 'L';
	lt['ŀ'] = 'l';
	lt['Ł'] = 'l';
	lt['ł'] = 'l';
	lt['Ń'] = 'N';
	lt['ń'] = 'n';
	lt['Ņ'] = 'N';
	lt['ņ'] = 'n';
	lt['Ň'] = 'N';
	lt['ň'] = 'n';
	lt['ŉ'] = 'n';
	lt['Ō'] = 'O';
	lt['ō'] = 'o';
	lt['Ŏ'] = 'O';
	lt['ŏ'] = 'o';
	lt['Ő'] = 'O';
	lt['ő'] = 'o';
	lt['Œ'] = 'OE';
	lt['œ'] = 'oe';
	lt['Ŕ'] = 'R';
	lt['ŕ'] = 'r';
	lt['Ŗ'] = 'R';
	lt['ŗ'] = 'r';
	lt['Ř'] = 'R';
	lt['ř'] = 'r';
	lt['Ś'] = 'S';
	lt['ś'] = 's';
	lt['Ŝ'] = 'S';
	lt['ŝ'] = 's';
	lt['Ş'] = 'S';
	lt['ş'] = 's';
	lt['Š'] = 'S';
	lt['š'] = 's';
	lt['Ţ'] = 'T';
	lt['ţ'] = 't';
	lt['Ť'] = 'T';
	lt['ť'] = 't';
	lt['Ŧ'] = 'T';
	lt['ŧ'] = 't';
	lt['Ũ'] = 'U';
	lt['ũ'] = 'u';
	lt['Ū'] = 'U';
	lt['ū'] = 'u';
	lt['Ŭ'] = 'U';
	lt['ŭ'] = 'u';
	lt['Ů'] = 'U';
	lt['ů'] = 'u';
	lt['Ű'] = 'U';
	lt['ű'] = 'u';
	lt['Ų'] = 'U';
	lt['ų'] = 'u';
	lt['Ŵ'] = 'W';
	lt['ŵ'] = 'w';
	lt['Ŷ'] = 'Y';
	lt['ŷ'] = 'y';
	lt['Ÿ'] = 'Y';
	lt['Ź'] = 'Z';
	lt['ź'] = 'z';
	lt['Ż'] = 'Z';
	lt['ż'] = 'z';
	lt['Ž'] = 'Z';
	lt['ž'] = 'z';
	lt['ſ'] = 's';
	lt['ƒ'] = 'f';
	lt['Ơ'] = 'O';
	lt['ơ'] = 'o';
	lt['Ư'] = 'U';
	lt['ư'] = 'u';
	lt['Ǎ'] = 'A';
	lt['ǎ'] = 'a';
	lt['Ǐ'] = 'I';
	lt['ǐ'] = 'i';
	lt['Ǒ'] = 'O';
	lt['ǒ'] = 'o';
	lt['Ǔ'] = 'U';
	lt['ǔ'] = 'u';
	lt['Ǖ'] = 'U';
	lt['ǖ'] = 'u';
	lt['Ǘ'] = 'U';
	lt['ǘ'] = 'u';
	lt['Ǚ'] = 'U';
	lt['ǚ'] = 'u';
	lt['Ǜ'] = 'U';
	lt['ǜ'] = 'u';
	lt['Ǻ'] = 'A';
	lt['ǻ'] = 'a';
	lt['Ǽ'] = 'AE';
	lt['ǽ'] = 'ae';
	lt['Ǿ'] = 'O';
	lt['ǿ'] = 'o';
	lt['Ѐ'] = 'E';
	lt['Ё'] = 'E';
	lt['Ђ'] = 'Dj';
	lt['Ѓ'] = 'G';
	lt['Є'] = 'E';
	lt['Ѕ'] = 'S';
	lt['І'] = 'I';
	lt['Ї'] = 'I';
	lt['Ј'] = 'J';
	lt['Љ'] = 'Ly';
	lt['Њ'] = 'Ny';
	lt['Ћ'] = 'Che';
	lt['Ќ'] = 'Ky';
	lt['Ѝ'] = 'Y';
	lt['Ў'] = 'U';
	lt['Џ'] = 'J';
	lt['А'] = 'A';
	lt['Б'] = 'B';
	lt['В'] = 'V';
	lt['Г'] = 'G';
	lt['Д'] = 'D';
	lt['Е'] = 'E';
	lt['Ж'] = 'J';
	lt['З'] = 'Z';
	lt['И'] = 'I';
	lt['Й'] = 'J';
	lt['К'] = 'K';
	lt['Л'] = 'L';
	lt['М'] = 'M';
	lt['Н'] = 'N';
	lt['О'] = 'O';
	lt['П'] = 'P';
	lt['Р'] = 'R';
	lt['С'] = 'S';
	lt['Т'] = 'T';
	lt['У'] = 'U';
	lt['Ф'] = 'F';
	lt['Х'] = 'H';
	lt['Ц'] = 'Ts';
	lt['Ч'] = 'Ch';
	lt['Ш'] = 'Sh';
	lt['Щ'] = 'Sht';
	lt['Ъ'] = 'A';
	lt['Ы'] = 'Y';
	lt['Ь'] = 'Y';
	lt['Э'] = 'E';
	lt['Ю'] = 'Yu';
	lt['Я'] = 'Ya';
	lt['а'] = 'a';
	lt['б'] = 'b';
	lt['в'] = 'v';
	lt['г'] = 'g';
	lt['д'] = 'd';
	lt['е'] = 'e';
	lt['ж'] = 'j';
	lt['з'] = 'z';
	lt['и'] = 'i';
	lt['й'] = 'y';
	lt['к'] = 'k';
	lt['л'] = 'l';
	lt['м'] = 'm';
	lt['н'] = 'n';
	lt['о'] = 'o';
	lt['п'] = 'p';
	lt['р'] = 'r';
	lt['с'] = 's';
	lt['т'] = 't';
	lt['у'] = 'u';
	lt['ф'] = 'f';
	lt['х'] = 'h';
	lt['ц'] = 'ts';
	lt['ч'] = 'ch';
	lt['ш'] = 'sh';
	lt['щ'] = 'sht';
	lt['ъ'] = 'a';
	lt['ы'] = 'y';
	lt['ь'] = 'y';
	lt['э'] = 'e';
	lt['ю'] = 'yu';
	lt['я'] = 'ya';
	lt['ѐ'] = 'ye';
	lt['ё'] = 'yo';
	lt['ђ'] = 'g';
	lt['ѓ'] = 'g';
	lt['є'] = 'ye';
	lt['ѕ'] = 'c';
	lt['і'] = 'i';
	lt['ї'] = 'y';
	lt['ј'] = 'j';
	lt['љ'] = 'ly';
	lt['њ'] = 'ny';
	lt['ћ'] = 'che';
	lt['ќ'] = 'k';
	lt['ѝ'] = 'i';
	lt['ў'] = 'u';
	lt['џ'] = 'j';
	lt['Ѣ'] = 'y';
	lt['ѣ'] = 'y';
	lt['Ґ'] = 'G';
	lt['ґ'] = 'g';
	lt['Ғ'] = 'G';
	lt['ғ'] = 'g';
	lt['Ҕ'] = 'G';
	lt['ҕ'] = 'g';
	lt['Җ'] = 'J';
	lt['җ'] = 'j';
	lt['Ҙ'] = 'Z';
	lt['ҙ'] = 'z';
	lt['Қ'] = 'K';
	lt['қ'] = 'k';
	lt['Ң'] = 'N';
	lt['ң'] = 'n';
	lt['Ҥ'] = 'Ng';
	lt['ҥ'] = 'ng';
	lt['Ҫ'] = 'S';
	lt['ҫ'] = 's';
	lt['Ҭ'] = 'T';
	lt['ҭ'] = 't';
	lt['Ү'] = 'Y';
	lt['ү'] = 'y';
	lt['Ұ'] = 'Y';
	lt['ұ'] = 'y';
	lt['Ҳ'] = 'H';
	lt['ҳ'] = 'h';
	lt['Һ'] = 'Sh';
	lt['һ'] = 'sh';
	lt['Ӏ'] = 'I';
	lt['Ӂ'] = 'J';
	lt['ӂ'] = 'j';
	lt['Ӄ'] = 'K';
	lt['ӄ'] = 'k';
	lt['Ӈ'] = 'N';
	lt['ӈ'] = 'n';
	lt['Ӌ'] = 'Ch';
	lt['ӌ'] = 'ch';
	lt['ӏ'] = 'i';
	lt['Ӑ'] = 'A';
	lt['ӑ'] = 'a';
	lt['Ӓ'] = 'A';
	lt['ӓ'] = 'a';
	lt['Ӕ'] = 'Ae';
	lt['ӕ'] = 'ae';
	lt['Ӗ'] = 'E';
	lt['ӗ'] = 'e';
	lt['Ә'] = 'A';
	lt['ә'] = 'a';
	lt['Ӛ'] = 'A';
	lt['ӛ'] = 'a';
	lt['Ӝ'] = 'J';
	lt['ӝ'] = 'j';
	lt['Ӟ'] = 'Z';
	lt['ӟ'] = 'z';
	lt['Ӡ'] = 'Z';
	lt['ӡ'] = 'z';
	lt['Ӣ'] = 'I';
	lt['ӣ'] = 'i';
	lt['Ӥ'] = 'I';
	lt['ӥ'] = 'i';
	lt['Ӧ'] = 'O';
	lt['ӧ'] = 'o';
	lt['Ө'] = 'O';
	lt['ө'] = 'o';
	lt['Ӫ'] = 'O';
	lt['ӫ'] = 'o';
	lt['Ӭ'] = 'E';
	lt['ӭ'] = 'e';
	lt['Ӯ'] = 'U';
	lt['ӯ'] = 'u';
	lt['Ӱ'] = 'U';
	lt['ӱ'] = 'u';
	lt['Ӳ'] = 'U';
	lt['ӳ'] = 'u';
	lt['Ӵ'] = 'Ch';
	lt['ӵ'] = 'ch';
	lt['Ӷ'] = 'G';
	lt['ӷ'] = 'g';
	lt['Ӹ'] = 'Y';
	lt['ӹ'] = 'y';
	lt['-'] = '-';
	lt['~'] = '-';
	lt['­'] = '-';
	lt['֊'] = '-';
	lt['־'] = '-';
	lt['᠆'] = '-';
	lt['‐'] = '-';
	lt['‑'] = '-';
	lt['‒'] = '-';
	lt['–'] = '-';
	lt['—'] = '-';
	lt['―'] = '-';
	lt['⁻'] = '-';
	lt['₋'] = '-';
	lt['−'] = '-';
	lt['⸗'] = '-';
	lt['〜'] = '-';
	lt['〰'] = '-';
	lt['゠'] = '-';
	lt['︱'] = '-';
	lt['﹣'] = '-';
	lt['－'] = '-';
	lt['〃'] = '`';
	lt['״'] = '`';
	lt['＂'] = '`';
	lt['ˮ'] = '`';
	lt['ײ'] = '`';
	lt['″'] = '`';
	lt['ʺ'] = '`';
	lt['˝'] = '`';
	lt['‶'] = '`';
	lt['‟'] = '`';
	lt['˶'] = '`';
	lt['”'] = '`';
	lt['“'] = '`';
	lt['№'] = 'N.';
	lt['0'] = '0';
	lt['1'] = '1';
	lt['2'] = '2';
	lt['3'] = '3';
	lt['4'] = '4';
	lt['5'] = '5';
	lt['6'] = '6';
	lt['7'] = '7';
	lt['8'] = '8';
	lt['9'] = '9';

	let res = '';
	let src = value;
	if (src === '')
		return '';
	for (let i = 0; i < src.length; i++) {
		let l = src.charAt(i);
		if (lt[l] == null) {
			l = l.toLowerCase();
			if (lt[l] == null)
				res = res + src.charAt(i);
			else {
				l = lt[l];
				res = res + l.toUpperCase();
			}
		} else
			res = res + lt[l];
	}
	// eslint-disable-next-line no-control-regex
	res = res.replace(/([^\x00-\xFF])*$/g, "");

	return res;
}

export function _canUseWebp(callback) {
	let webpImg = 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==';
	let img = new Image();
	img.onload = function () {
		var result = (img.width > 0) && (img.height > 0);
		callback(result);
	};
	img.onerror = function () {
		callback(false);
	};
	img.src = "data:image/webp;base64," + webpImg;
}

/**
 * Проверява дали даден ключ/property съществува в даден обект.
 *
 * @property {object} object
 * @property {string} property
 * @returns boolean
 */
export function _hasProperty(object, property) {
	if (object === null || object === undefined) {
		return false;
	}
	return Object.prototype.hasOwnProperty.call(object, property);
}

/**
 * за циклене в масив и обект
 *
 * @callback mapThroughObjectAndArrayCallback
 * @param {string|number} index - ключ
 * @param {*} value - стойност
 */

/**
 *
 * @param {(Array|Object)} data
 * @param {mapThroughObjectAndArrayCallback} callback
 * @return {*[]}
 * @private
 */
export function _foreach(data, callback) {
	const resultArray = [];

	let length = 0;
	if (typeof data === "object") {
		length = Object.keys(data).length;
		const keys = Object.keys(data);

		for (let index = 0; index < length; index++) {
			resultArray.push(callback(keys[index], data[keys[index]]));
		}
	} else if (Array.isArray(data)) {
		length = data.length;

		for (let index = 0; index < length; index++) {
			resultArray.push(callback(index, data[index]));
		}
	} else {
		console.error("_foreach: Invalid data type!");
		return;
	}

	return resultArray;
}

export function _goToBlank(url) {
	// Create link in memory
	const a = window.document.createElement("a");
	a.target = "_blank";
	a.href = url;

	// Dispatch fake click
	const e = window.document.createEvent("MouseEvents");
	e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	a.dispatchEvent(e);

	a.remove();
}

export function _getEndOfMonth(separator = '') {

	let today = new Date();
	let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

	let date = lastDayOfMonth.getDate();
	let month = lastDayOfMonth.getMonth() + 1;
	let year = lastDayOfMonth.getFullYear();

	return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
}

export default class HelperFunc {

	static goToBlank(url) {
		return _goToBlank(url);
	}

	static extractDomainTLD(email) {
		return _extractDomainTLD(email);
	}

	static truncateDomainName(domainNameFull, domain_tld, maxLen) {
		return _truncateDomainName(domainNameFull, domain_tld, maxLen);
	}

	static isInViewport(element, partiallyVisible = false) {
		return _isInViewport(element, partiallyVisible);
	}

	static isMobile() {
		return _isMobile();
	}

	static isTablet() {
		return _isTablet();
	}

	static isDesktop() {
		return _isDesktop();
	}

	static translateToLatin(value) {
		return _translateToLatin(value);
	}

	static _canUseWebp(callback) {
		return _canUseWebp(callback);
	}

	static foreach(data, callback) {
		return _foreach(data, callback);
	}

	static hasProperty(object, property) {
		return _hasProperty(object, property);
	}

	static getEndOfMonth(separator) {
		return _getEndOfMonth(separator);
	}


	static scorePassword(separator) {
		return _scorePassword(separator);
	}
}

